<template>
    <div class="page_container">
        <!-- 头部 -->
        <head-bar title="交易记录" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 头部 -->
        <!-- 导航 -->
        <div class="table_nav">
            <div class="tab" ref="tab">
                <span
                    v-for="(item, index) in searchOptions"
                    :key="index"
                    :class="{
                        active: activeIndex == item.value,
                    }"
                    @click="tabClick(index, item.value)"
                >
                    {{ item.name }}
                </span>
                <i ref="scrollBar"></i>
            </div>
        </div>
        <!-- 导航 -->
        <div class="scroll_container">
            <scroll
                v-if="transactionList.length > 0"
                :data-list="transactionList"
                :finished="finished"
                @load="getTransactionList"
            >
                <div class="scroll_list">
                    <!-- 交易列表 -->
                    <div class="transaction_list">
                        <div
                            class="transaction_item"
                            v-for="(item, index) in transactionList"
                            :key="index"
                        >
                            <div class="company_info">
                                <span>{{ item.tradeTarget }}</span>
                                <div class="consumption_text">
                                    ¥&nbsp;{{ item.tradeAmount }}
                                </div>
                            </div>
                            <div class="common_info">
                                <div class="common_info_line common_info_left">
                                    <span>{{ item.tradeTypeDesc }}</span>
                                </div>
                                <div class="common_info_line common_info_right">
                                    <span>{{ item.tradeStateDesc }}</span>
                                </div>
                            </div>
                            <div class="common_info">
                                <div class="common_info_line common_info_left">
                                    <span>{{ item.tradeTime }}</span>
                                </div>
                                <div class="common_info_line common_info_right">
                                    <span
                                        >余额&nbsp;¥&nbsp;{{
                                            item.cashBalance
                                        }}</span
                                    >
                                </div>
                            </div>
                            <div class="common_info" v-if="item.showAmountMsg">
                                <div class="remark_text">
                                    <p>{{ item.showAmountMsg }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 交易列表 -->
                </div>
            </scroll>
            <empty-data
                v-else
                iconText="暂无订单"
                :iconSrc="emptyIcon"
                :paddingTop="7"
                iconSize="slim"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { List, Toast } from "vant";
import Scroll from "@/components/Scroll";
import EmptyData from "@/components/EmptyData";
import HeadBar from "@/components/HeadBar";
import { isEmpty } from "../../../utils/validation";
Vue.use(List).use(Toast);

import {
    SEARCH_TYPE_ENTRY,
    SEARCH_TYPE_WITHDRAWAL,
    SEARCH_TYPE_ORDER,
    SEARCH_TYPE_ALL,
} from "../../../definition/type/wallet";

function getSearchIndex(source, value) {
    let zIndex = 0;
    source.forEach(function(item, index) {
        if (item.value == value) {
            zIndex = index;
        }
    });
    return zIndex;
}

export default {
    components: { Scroll, EmptyData, HeadBar },
    data() {
        return {
            /* 路由参数 */
            query: {
                index: this.$route.query.index,
            },
            // 空数据icon
            emptyIcon: require("../../../public/images/user/wallet/transaction_empty.png"),
            activeIndex: 0, // tab标签选中位置
            searchType: "", //搜索的类型
            /* 列表数据 */
            transactionList: [],
            finished: true,
            /* 分页数据 */
            page: {
                currPage: 1,
                pageSize: this.$config.PAGE_ITEMS,
            },
            totalCount: 0,
            isLoad: false,
            searchOptions: [
                {
                    name: "全部",
                    value: SEARCH_TYPE_ALL,
                },
                {
                    name: "订单记录",
                    value: SEARCH_TYPE_ORDER,
                },
                {
                    name: "预付款记录",
                    value: SEARCH_TYPE_ENTRY,
                },
                {
                    name: "退回预付款记录",
                    value: SEARCH_TYPE_WITHDRAWAL,
                },
            ],
        };
    },
    created() {},
    mounted() {
        this.$nextTick(() => {
            let { search } = this.$route.query;
            if (isEmpty(search)) {
                search = SEARCH_TYPE_ENTRY;
            }
            this.tabClick(getSearchIndex(this.searchOptions, search), search);
        });
    },
    methods: {
        /* 获取订单列表 */
        getTransactionList() {
            // 获取订单状态码
            // const orderStateArr = ["", 101, 102, 199, 449, 501, 601];
            // const orderState = orderStateArr[this.activeIndex];
            // 获取数据
            if (this.isLoad) return;
            const url = this.$api.userApi.queryWalletRecharge;
            const page = this.page.currPage || 1;
            const defaultPageSize = 10;
            const params = {
                page: {
                    currPage: page,
                    pageSize: defaultPageSize,
                },
                context: {
                    tradeType: this.searchType,
                },
            };
            let _this = this;
            this.isLoad = true;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(url, params)
                .then((res) => {
                    let {
                        data: transactionList = [],
                        totalCount = 0,
                    } = res.data;
                    this.transactionList = this.transactionList.concat(
                        transactionList
                    );
                    this.totalCount = totalCount;
                    this.page.currPage++;
                    // 数据全部加载完成
                    if (this.transactionList.length >= totalCount) {
                        this.finished = true;
                    }
                })
                .finally(() => {
                    _this.isLoad = false;
                    _this.$toast.clear();
                })
                .catch(({ msg, code }) => {
                    const inexistence_code = 60009;
                    if (code == inexistence_code) {
                        _this.$router.go(-1);
                    }
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                });
        },
        /* tab点击事件 */
        tabClick(index, value) {
            const $tab = this.$refs.tab;
            let clientWidth = $tab.children[index].clientWidth;
            let offsetLeft = $tab.children[index].offsetLeft;
            let scrollBar = this.$refs.scrollBar;
            scrollBar.style.transform = `translateX(${offsetLeft}px)`;
            scrollBar.style.width = `${clientWidth}px`;
            if (value == SEARCH_TYPE_ORDER || value == SEARCH_TYPE_ALL) {
                wx.redirectTo({
                    url: "test?id=1",
                });
            } else {
                this.searchType = value;
                this.reloadPageInfo();
            }
        },
        /* 重新获取页面数据 */
        reloadPageInfo() {
            // 重置 列表数据、当前页数、加载状态等，并获取数据
            this.transactionList = [];
            this.page.currPage = 1;
            this.finished = false;
            this.isLoad = false;
            this.getTransactionList();
        },
    },
};
</script>

<style lang="less" scoped>
.page_container {
    position: fixed;
    z-index: 0;
    width: 750px;
    left: 50%;
    top: 0;
    bottom: 0;
    margin-left: -375px;
}
.table_nav {
    position: absolute;
    z-index: 10;
    top: 90px;
    left: 0;
    width: 750px;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    font-size: 28px;
    .tab {
        overflow-x: auto;
        overflow-y: hidden;
        height: 100px;
        white-space: nowrap;
        position: relative;

        span {
            *display: inline;
            display: inline-block;
            zoom: 1;
            padding: 0 30px;
            text-align: center;
            height: 100px;
            line-height: 100px;
            text-align: center;

            &.active {
                color: @theme-color;
                font-weight: bold;
            }
        }

        i {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 70px;
            height: 4px;
            background-color: @theme-color;
            transition-duration: 0.3s;
        }
    }
}
.scroll_container {
    width: 750px;
    position: absolute;
    z-index: 10;
    top: 192px;
    left: 0;
    bottom: 0;
    .scroll_list {
    }
}

.transaction_list {
    > .transaction_item {
        padding: 40px;
        width: 670px;
        border-top: 1px solid #f6f6f6;
        background-color: #fff;
        .company_info {
            position: relative;
            font-size: 28px;
            line-height: 55px;
            font-weight: 400;
            color: #333333;
            .consumption_text {
                position: absolute;
                z-index: 10;
                top: 0;
                right: 0;
                font-size: 28px;
                line-height: 55px;
                font-weight: 400;
                color: #333333;
            }
        }
        .common_info {
            position: relative;
            height: 55px;
            .common_info_line {
                font-size: 28px;
                height: 55px;
                line-height: 55px;
                font-weight: 400;
                color: #999;
            }
            .common_info_left {
                float: left;
                width: 50%;
            }
            .common_info_right {
                float: right;
                width: 50%;
                text-align: right;
            }

            .remark_text {
                font-size: 28px;
                line-height: 1.5;
                text-align: center;
                color: #de9013;
                word-break: break-all;
            }
        }
    }
}
</style>
